import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps, Typography } from "@mui/material";
import { Stack } from "../../components";

export type TextFieldProps = MuiTextFieldProps & {};

export const TextField = ({ label, value, required, ...rest }: TextFieldProps) => {
  return (
    <MuiTextField
      //   label={
      //     <Stack direction="row" spacing="xs">
      //       <Typography>{label}</Typography>
      //       {required ? <Typography color="error">*</Typography> : ""}
      //     </Stack>
      //   }
      //   required={false}
      value={value || ""}
      label={label}
      required={required}
      {...rest}
    />
  );
};
